import { Image } from '~/components/Image';
import Typography from '~/components/Typography';

import type { Recommendation } from '~/interfaces/recommendation';

import useRecommendations from '~/hooks/useLoaders/useRecommendations';

import Section from './Section';
import SectionLoader from './SectionLoader';

interface Props {
  textColor: any;
  fontFamily: string;
  isNewWebBuilder?: boolean;
}

const RecommendationsWidgetSection = ({ textColor, fontFamily, isNewWebBuilder = false }: Props) => {
  const { recommendations } = useRecommendations();

  return (
    <Section
      text="Recommendations"
      viewMoreLink={'/recommendations'}
      textColor={textColor}
      fontFamily={fontFamily}
      isNewWebBuilder={isNewWebBuilder}
    >
      {recommendations ? (
        <div className="space-y-2 pr-4">
          {recommendations.recommendations.map((rec: Recommendation) => {
            return (
              <div key={rec.id} className="flex items-center space-x-2 truncate">
                <div>
                  <div className="h-6 w-6 overflow-hidden rounded border border-gray-300 bg-white">
                    <Image
                      maxWidth={128}
                      aspectRatio={'square'}
                      src={rec.publication.thumbnail_image_url}
                      alt={rec.publication.name}
                    />
                  </div>
                </div>

                <Typography
                  as="span"
                  color={textColor}
                  fontFamily={fontFamily}
                  size="sm"
                  className="truncate font-medium"
                >
                  {rec.publication.name}
                </Typography>
              </div>
            );
          })}
        </div>
      ) : (
        <SectionLoader />
      )}
    </Section>
  );
};

export default RecommendationsWidgetSection;
